import { Link } from "react-router-dom";

export const Header = () => {
  return (
    <header className="sticky top-0 z-50 bg-white border-b-2 border-black">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 h-16 flex items-center justify-between">
        <Link to="/" data-testid="logo-link" className="font-display font-black text-xl sm:text-2xl tracking-tighter">
          RAW<span className="text-pink">FEMME</span> / OPPS
        </Link>
      </div>
    </header>
  );
};
